// extracted by mini-css-extract-plugin
export default {"bullets":"Bullets_bullets__++bgV","border":"Bullets_border__8a0Zt","circle":"Bullets_circle__wsfbl","active":"Bullets_active__7ttbi"};